import { isAxiosError } from 'axios'
import { withJamParams } from '../util/recordingNavigation'

export function handleCatalogMode(error: unknown): Promise<never> {
  if (
    isAxiosError<{ error?: unknown }>(error) &&
    error.response?.status === 403 &&
    error.response.data?.error === 'catalog_mode'
  ) {
    window.location.replace(withJamParams('/cart', window.location.search))
  }

  return Promise.reject(error)
}
